// Lynk Consumer: OAuth Service
export const CONSUMER_OATH = '/oauth/token';
export const STAFF_URL = 'v3/staff';
